import { ROUTES } from '@constants/routes';

export function getNavigationState(pathname) {
  return {
    isHome: pathname === ROUTES.HOME,
    isAllEpisodes: pathname === ROUTES.ALL_EPISODES
  };
}
